import duotone from 'icons/duotone';

// Export navigation items structure for use in other components
export const getAllNavigationItems = (userRole = '', districtCount = '0') => {
  return [
    {
      name: 'Dashboard',
      path: '/dashboard/analytics',
      icon: duotone.Dashboard,
      // badge: {
      //   value: districtCount
      // },
      permission: 'dashboard',
      component: 'Analytics', // Add component identifier
      subTabs: []
    },
    {
      name: 'App Order',
      icon: duotone.DataTable,
      path: '/dashboard/orders-management',
      permission: 'appOrders',
      component: 'OrdersManagement',
      subTabs: []
    },
    {
      name: 'Agronomist',
      icon: duotone.PersonChalkboard,
      path: '/dashboard/agronomist',
      permission: 'talkToAgronomist',
      component: 'Agronomist',
      subTabs: []
    },
    {
      name: 'Bulk Order',
      icon: duotone.LayerGroup,
      path: '/dashboard/bulk-upload',
      permission: 'bulkOrders',
      component: 'BulkUpload',
      subTabs: []
    },
    {
      name: 'Return & Cancel Request',
      icon: duotone.LayerGroup,
      path: '/dashboard/return-cancel-request',
      permission: 'returnCancelRequest',
      component: 'ReturnCancelRequest',
      subTabs: []
    },
    {
      name: 'Quotation',
      icon: duotone.FileCircleQuotation,
      path: '/dashboard/Quotation-proforma',
      permission: 'quotation',
      component: 'QuotationProforma',
      subTabs: []
    },
    {
      name: 'Farmers',
      icon: duotone.UserList,
      path: '/dashboard/farmers',
      permission: 'farmerManagement',
      component: 'Farmers',
      subTabs: []
    },
    {
      name: 'Agri-store',
      icon: duotone.Ecommerce,
      path: '/dashboard/products-management',
      permission: 'agriStore',
      component: 'ProductsManagement',
      subTabs: []
    },
    {
      name: 'Translated Content',
      icon: duotone.ElementHub,
      path: '/dashboard/groceries',
      permission: 'groceries',
      component: 'Groceries',
      subTabs: []
    },
    {
      name: 'Posts',
      icon: duotone.Chat,
      path: '/dashboard/posts',
      permission: 'farmerForum',
      component: 'Posts',
      subTabs: []
    },
    {
      name: 'Knowledge Hub ',
      icon: duotone.Pages,
      path: '/dashboard/courses',
      permission: 'successStories',
      component: 'Courses',
      subTabs: []
    },
    {
      name: 'Event Types',
      icon: duotone.Calender,
      path: '/dashboard/event-types',
      permission: 'eventType',
      component: 'EventTypes',
      subTabs: []
    },
    {
      name: 'Crop Types',
      icon: duotone.DiagramProject,
      path: '/dashboard/crop-types',
      permission: 'cropType',
      component: 'CropTypes',
      subTabs: []
    },
    {
      name: 'Enquiry Form',
      icon: duotone.FileCircleQuestion,
      path: '/dashboard/enquiry-form',
      permission: 'enquiry',
      component: 'EnquiryForm',
      subTabs: []
    },
    {
      name: 'Field Visit',
      icon: duotone.PersonCircleCheck,
      path: '/dashboard/field-visit',
      permission: 'fieldVisit',
      component: 'FieldVisit',
      subTabs: []
    },
    {
      name: 'Category',
      icon: duotone.Invoice,
      path: '/dashboard/invoice',
      permission: 'invoice',
      component: 'Invoice',
      subTabs: []
    },
    {
      name: 'Crop Hub',
      icon: duotone.Plant,
      path: '/dashboard/crop-hub',
      permission: 'cropHub',
      component: 'CropHub',
      subTabs: []
    },
    {
      name: 'Disease Advisory',
      icon: duotone.CommentsQuestionCheck,
      path: '/dashboard/disease-advisory',
      permission: 'diseaseAdvisory',
      component: 'DiseaseAdvisory',
      subTabs: []
    },
    {
      name: 'AI Chat Bot',
      icon: duotone.Chat,
      path: '/dashboard/ai-chat-bot',
      permission: 'aiChatBot',
      component: 'AIChatBot',
      subTabs: []
    },
    {
      name: 'Users',
      icon: duotone.Accounts,
      path: '/dashboard/users',
      permission: 'users',
      component: 'Users',
      subTabs: []
    },
    {
      name: 'Permissions',
      icon: duotone.TodoList,
      path: '/dashboard/permissions',
      permission: 'permissions',
      component: 'Permissions',
      subTabs: []
    },
    {
      name: 'FAQs',
      icon: duotone.FileCircleQuotation,
      path: '/dashboard/FAQ',
      permission: 'FAQs',
      component: 'FAQs',
      subTabs: []
    },
    {
      name: 'Report',
      icon: duotone.Invoice,
      path: '/dashboard/report',
      permission: 'report',
      component: 'Report',
      subTabs: []
    }
  ];
};

// Main function to get navigations based on user permissions
export const getNavigations = () => {
  try {
    const loggedData = JSON.parse(localStorage.getItem("logged_data")) || {};
    const userRole = loggedData?.data?.user_type || '';
    const permissions = loggedData?.data?.permissions || {};
    
    const allNavigations = getAllNavigationItems(userRole, '0');

    // Filter based on permissions
    if (permissions && Object.keys(permissions).length > 0) {
      const filteredNavs = allNavigations.filter(nav => {
        if (nav.permission === 'dashboard') {
          return permissions.dashboard?.allowed === true;
        }
        if (nav.permission === 'FAQs') {
          return permissions.FAQs?.allowed === true || 
                 permissions.faq?.allowed === true || 
                 permissions.FAQ?.allowed === true;
        }
        return permissions[nav.permission]?.allowed === true;
      });
      
      return filteredNavs.map(nav => ({ ...nav, subTabs: [] }));
    }
    
    // Fallback for admin/co_admin users
    if (userRole === 'Admin' || userRole === 'Company' || userRole === 'co_admin') {
      return allNavigations.map(nav => ({ ...nav, subTabs: [] }));
    } else if (userRole === 'chapter_admin') {
      return [
        { ...allNavigations[0], subTabs: [] },
        { ...allNavigations[1], subTabs: [] }
      ];
    }

    return [];
  } catch (error) {
    console.error('Error getting navigations:', error);
    return [];
  }
};

export const navigations = getNavigations();
export const refreshNavigations = () => getNavigations();